"use client";

import React from "react";
import { ArrowRight, Martini } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const signatureDrinks = [{
  name: "Complimentary Shipping",
  ingredients: "Enjoy door-to-door delivery on all seasonal releases and boutique orders over six bottles.",
  pairing: "Sustainable Delivery",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/winery_shipping.png"
}, {
  name: "Private Estate Tastings",
  ingredients: "Exclusive access to our library cellar and guided vertical tastings with our lead viticulturist.",
  pairing: "Member Exclusive",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/winery_tasting.png"
}, {
  name: "Early Vintage Access",
  ingredients: "Priority allocation for our limited-production Reserve Merlot and experimental small-batch lots.",
  pairing: "Priority Allocation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/winery_vintage.png"
}];
export default function SignatureDrinks() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="135618" id="member-benefits" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex justify-center mb-4">
            <Martini className="w-8 h-8 text-secondary opacity-90" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight mb-6">
            Exclusive Privileges
          </h2>
          <p className="font-sans text-lg text-muted-foreground leading-relaxed tracking-normal">
            Experience the pinnacle of VineEssence. Our Cellar Club offers more than just wine; 
            it provides a gateway to the terroir and the meticulous craft of our private estate.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {signatureDrinks.map((drink, i) => <Card key={drink.name} data-index={i} className="flex flex-col h-full overflow-hidden border-border/40 bg-card/40 backdrop-blur-sm hover:border-secondary/50 hover:shadow-[inset_0_0_20px_rgba(184,151,85,0.15)] transition-all duration-300 rounded-none">
              <img src={drink.image} alt={drink.name} className="w-full h-[400px] object-cover transition-transform duration-1000 hover:scale-105" />
              <CardHeader className="pt-8 pb-4 px-8">
                <CardTitle className="font-serif text-2xl md:text-3xl mb-3 tracking-tight">
                  {drink.name}
                </CardTitle>
                <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed tracking-normal">
                  {drink.ingredients}
                </CardDescription>
              </CardHeader>
              <CardContent className="px-8 pb-8 flex-grow flex items-end">
                <Badge variant="outline" className="bg-background/30 border-border/60 text-foreground/80 font-mono py-1.5 px-3 text-[10px] tracking-widest uppercase rounded-none">
                  Membership Benefit: {drink.pairing}
                </Badge>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="mt-20 text-center">
          <Link to="/CellarClubPage">
            <Button size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 h-14 px-10 text-base font-sans tracking-wider shadow-lg shadow-black/20 transition-all duration-300 hover:-translate-y-1 rounded-none">
              Join the Cellar Club
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}